import cx from 'classnames'
import React from 'react'
import style from './index.scss'

interface Props {
  googleLogin?: () => void
  className?: string
}

const GoogleLoginButton: React.FC<Props> = (props) => {
  return (
    <button
      className={cx(style.googleButton, props.className)}
      onClick={props.googleLogin}
      type="button"
    >
      <svg
        style={{ width: '20px', height: '20px' }}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={style.googleIcon}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.36 8.17463C15.36 7.63099 15.3112 7.10826 15.2206 6.60645H8V9.57205H12.1261C11.9483 10.5304 11.4082 11.3424 10.5962 11.886V13.8096H13.0739C14.5236 12.4749 15.36 10.5095 15.36 8.17463Z"
          fill="#4285F4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99996 15.667C10.07 15.667 11.8054 14.9805 13.0739 13.8096L10.5962 11.886C9.90965 12.346 9.03147 12.6178 7.99996 12.6178C6.00314 12.6178 4.31299 11.2692 3.71011 9.45703H1.14874V11.4434C2.41026 13.949 5.00299 15.667 7.99996 15.667Z"
          fill="#34A853"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.71013 9.45634C3.5568 8.99634 3.46968 8.50497 3.46968 7.99967C3.46968 7.49437 3.5568 7.003 3.71013 6.543V4.55664H1.14877C0.629525 5.59164 0.333313 6.76255 0.333313 7.99967C0.333313 9.23679 0.629525 10.4077 1.14877 11.4427L3.71013 9.45634Z"
          fill="#FBBC05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99996 3.38225C9.12556 3.38225 10.1362 3.76907 10.9307 4.52877L13.1297 2.32983C11.8019 1.0927 10.0665 0.333008 7.99996 0.333008C5.00299 0.333008 2.41026 2.05104 1.14874 4.55664L3.71011 6.54301C4.31299 4.73089 6.00314 3.38225 7.99996 3.38225Z"
          fill="#EA4335"
        />
      </svg>
      <div className={style.continueWithGoogle}>Continue with Google</div>
    </button>
  )
}

export default GoogleLoginButton
